import { HTMLAttributes, ReactNode } from 'react';

import classes from './Button.module.css';
import cn from 'classnames';

export type ButtonProps = {
  children?: ReactNode;
  variant: 'primary' | 'secondary' | 'danger' | 'neutral' | 'success';
  color?: 'normal' | 'light';
  disabled?: boolean;
  type?: 'submit' | 'button';
  size?: 'large' | 'medium' | 'small';
} & HTMLAttributes<HTMLButtonElement>;

export const Button = ({
  children,
  color = 'normal',
  variant = 'primary',
  disabled = false,
  type = 'button',
  size = 'large',
  ...rest
}: ButtonProps) => {
  const isDisabledClassName = disabled ? classes.disabled : undefined;

  const combinedButtonClass = cn(
    classes.button,
    classes[size],
    classes[variant],
    classes[color],
    isDisabledClassName,
    rest.className,
  );
  return (
    <button
      {...rest}
      className={combinedButtonClass}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
